import React from 'react';
import { useLocation } from 'react-router-dom';
import { Action, EmptyState, PageBody, Panel } from '../../components/aa';

/* An address inside the partner console that leads nowhere says so, rather
   than quietly landing on another screen. */
const PartnerNotFound: React.FC = () => {
  const { pathname } = useLocation();
  return (
    <PageBody>
      <Panel>
        <EmptyState
          title="Page not found"
          reason={<>There is no page at <span className="break-all font-mono text-[12px] text-ink">{pathname}</span>. It may have moved, or the link may be mistyped.</>}
          action={<Action to="/partner/framework">Go to your partner home</Action>}
        />
      </Panel>
    </PageBody>
  );
};

export default PartnerNotFound;
